import { BayLevelEnum, TContainerLengths } from "open-vessel-definition";
import {
  IBayPattern,
  IPositionPattern,
  IRowPattern,
  ITierPattern,
} from "./IPositionPatterns";

export interface IContainerInformation {
  pk: string;
  position: IPositionPattern;
  size: TContainerLengths;
  height: number;
  width: number;
  isReefer?: 0 | 1;
  isAbove: 0 | 1;
  // iOddBay: number;
}

export interface IContainerInformationExtended extends IContainerInformation {
  iBay: number;
  bay: IBayPattern;
  level: BayLevelEnum.ABOVE | BayLevelEnum.BELOW;
  row: IRowPattern;
  tier: ITierPattern;
  invalidReason?: EInvalidContainerReasonEnum;
}

export enum EInvalidContainerReasonEnum {
  REPEATED_CELL = "REPEATED_CELL",
  INEXISTENT_BAY = "INEXISTENT_BAY",
  INEXISTENT_ROW = "INEXISTENT_ROW",
  INEXISTENT_TIER = "INEXISTENT_TIER",
  INVALID_POSITION = "INVALID_POSITION",
}
